// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Private Endpoint Service API
 * private-endpoint-service-api manages Private Endpoint Services in ingress clusters
 *
 * The version of the OpenAPI document: 1.0
 * Contact: team-aura-networking@neotechnology.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { EndToEndState } from './EndToEndState';
import {
  EndToEndStateFromJSON,
  EndToEndStateFromJSONTyped,
  EndToEndStateToJSON,
  EndToEndStateToJSONTyped,
} from './EndToEndState';

/**
 *
 * @export
 * @interface InternalProjectScopedOverview
 */
export interface InternalProjectScopedOverview {
  /**
   * False when no PrivateEndpointServiceCustomer CR exists for this org/project/region, meaning PES has not been enabled. All other fields are absent in that case.
   *
   * @type {boolean}
   * @memberof InternalProjectScopedOverview
   */
  enabled: boolean;
  /**
   * Infrastructure-level issues that are not hard errors (e.g. a CRD not installed on the cluster).
   * @type {Array<string>}
   * @memberof InternalProjectScopedOverview
   */
  warnings?: Array<string>;
  /**
   *
   * @type {EndToEndState}
   * @memberof InternalProjectScopedOverview
   */
  overview?: EndToEndState;
}

/**
 * Check if a given object implements the InternalProjectScopedOverview interface.
 */
export function instanceOfInternalProjectScopedOverview(
  value: object,
): value is InternalProjectScopedOverview {
  if (!('enabled' in value) || value['enabled'] === undefined) return false;
  return true;
}

export function InternalProjectScopedOverviewFromJSON(
  json: any,
): InternalProjectScopedOverview {
  return InternalProjectScopedOverviewFromJSONTyped(json, false);
}

export function InternalProjectScopedOverviewFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): InternalProjectScopedOverview {
  if (json == null) {
    return json;
  }
  return {
    enabled: json['enabled'],
    warnings: json['warnings'] == null ? undefined : json['warnings'],
    overview:
      json['overview'] == null
        ? undefined
        : EndToEndStateFromJSON(json['overview']),
  };
}

export function InternalProjectScopedOverviewToJSON(
  json: any,
): InternalProjectScopedOverview {
  return InternalProjectScopedOverviewToJSONTyped(json, false);
}

export function InternalProjectScopedOverviewToJSONTyped(
  value?: InternalProjectScopedOverview | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    enabled: value['enabled'],
    warnings: value['warnings'],
    overview: EndToEndStateToJSON(value['overview']),
  };
}
